import { Dispatch, forwardRef, SetStateAction } from 'react'
import './Input.css'
import { useTranslation } from 'react-i18next'
import { ReactComponent as IcPassed } from '../../../assets/svgs/icon/ic_passed.svg'
import { ReactComponent as IcError } from'../../../assets/svgs/icon/ic_error.svg'
import { palette } from 'common/commonStyle'
import { info } from 'console'

export interface InputInfoMsg {
    msg: string,
    type: "passed" | "error"
}

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    inputVal: string
    setInputVal?: Dispatch<SetStateAction<string>>
    title?: string
    infoMsg?: InputInfoMsg
    isRequired?: boolean
    notShowInfo? : boolean
    containerStyle?: React.CSSProperties
}


export const Input = forwardRef<HTMLInputElement, InputProps>(({
    title,
    infoMsg,
    inputVal,
    setInputVal,
    isRequired,
    notShowInfo,
    containerStyle,
    ...rest
}, ref) => {
    const {t} = useTranslation();

    return (
        <div style={containerStyle ?? {padding: "10px 0"}}>
            {title &&
                <div className="common-input-title-container">
                    <span className="common-input-title">{title}</span>
                    {isRequired && 
                        <span className="common-input-required">{t("required")}</span>
                    }
                </div>
            }
            <input
                ref={ref}
                className="common-input"
                {...rest}
                value={inputVal}
                onChange={(e) => {
                    setInputVal && setInputVal(e.target.value)
                    rest.onChange?.(e)
                }}
            />
            {!notShowInfo && 
                <div className="common-input-msg-wrapper">
                    {infoMsg &&
                        <>
                            {infoMsg.type === "error" &&
                                <IcError
                                    height="12px"
                                    width="12px"
                                    color={palette.warning}
                                />
                            }
                            {infoMsg.type === "passed" &&
                                <IcPassed
                                    height="12px"
                                    width="12px"
                                    color={palette.primary}
                                />
                            }
                            <span className={`common-input-msg ${infoMsg.type}`}>{infoMsg.msg}</span>
                        </>
                    }
                </div>
            }
            
        </div>
    )
});